import apiService from "./api";
import { sanitizeQueryParams } from "../utility/helpers/apiHelper";
import type { SortOrderValue } from "@src/shared/constants/sort-order.constants";
import type { PaginationAndOrderParams } from "@src/shared/types/pagination.types";

export interface GetRefundsParams
  extends Partial<
    Omit<PaginationAndOrderParams, "page" | "pageSize" | "orderDirection">
  > {
  page?: number | string;
  pageSize?: number | string;
  search?: string;
  status?: string;
  type?: string;
  businessId?: string | number;
  orderDirection?: SortOrderValue | Lowercase<SortOrderValue>;
}

export interface RefundUserRecord {
  id?: number;
  firstName?: string | null;
  lastName?: string | null;
  email?: string | null;
}

export interface RefundItemRecord {
  name?: string | null;
  quantity?: number;
  price?: number;
  discountAmount?: number;
  totalAmount?: number;
  itemType?: string | null;
  itemId?: number | string | null;
  bookingId?: number | string | null;
  businessId?: number;
  businessName?: string | null;
  transactionId?: number;
  orderDate?: string;
}

export interface RefundRecord {
  id?: number | string;
  transactionId?: number | string;
  transactionItemId?: number | string;
  productReturnId?: number | string;
  itemName?: string | null;
  type?: string | null;
  reason?: string | null;
  internalNote?: string | null;
  requesterName?: string | null;
  requesterEmail?: string | null;
  requestedBy?: RefundUserRecord | null;
  approvedBy?: RefundUserRecord | null;
  processedBy?: RefundUserRecord | null;
  businessId?: number;
  businessName?: string | null;
  refundAmount?: number;
  cancellationFee?: number;
  netRefundAmount?: number;
  currency?: string | null;
  status?: string | null;
  item?: RefundItemRecord;
  createdAt?: string;
  updatedAt?: string;
}

export class RefundService {
  async getRefunds(query: GetRefundsParams) {
    return apiService.get("/refund-requests", {
      params: sanitizeQueryParams(query),
    });
  }

  async getRefund(id: string) {
    return apiService.get(`/refund-requests/${id}`);
  }

  async retryRefundPayment(id: string) {
    return apiService.post(`/refund-requests/${id}/retry`);
  }
}

export const refundService = new RefundService();
